(() => {
  'use strict';
  const bind = root => {
    root.querySelectorAll('[data-policy-page]').forEach(page => {
      if (page.dataset.bound) return;
      page.dataset.bound = 'true';
      const index = page.querySelector('[data-policy-index]');
      page.querySelectorAll('[data-policy-content] h2').forEach((heading, i) => {
        heading.id = `Policy-${page.dataset.policyPage}-${i + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        index.append(item);
      });
      if (!index.children.length) page.querySelector('.tr-policy-index').hidden = true;
    });
    root.querySelectorAll('[data-personalizer]').forEach(product => {
      if (product.dataset.v4Bound) return;
      product.dataset.v4Bound = 'true';
      if (product.querySelector('[data-gift-toggle]').checked) product.querySelector('[data-gift-details]').open = true;
      const slides = product.querySelector('[data-product-slides]');
      const thumbs = [...product.querySelectorAll('[data-product-slide]')];
      const update = () => {
        const index = Math.round(slides.scrollLeft / (slides.clientWidth || 1));
        thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      };
      slides.addEventListener('scroll', update, {passive: true});
      thumbs.forEach((button, i) => button.addEventListener('click', () => thumbs.forEach((other, j) => other.setAttribute('aria-pressed', String(i === j)))));
    });
  };
  document.addEventListener('trazzo:photo-preview', event => {
    if (!event.detail.url) return;
    document.querySelectorAll('[data-preview-details]').forEach(details => { details.open = true; });
  });
  document.addEventListener('DOMContentLoaded', () => bind(document));
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
